





















































import Vue from 'vue'
import vClickOutside from 'v-click-outside'
import { DataTableColumnItem } from '@/models/dataTable'
import { ResSavedFilter, ReqSavedFilter } from '@/models/users'
import { mapGetters, mapActions } from 'vuex'
import { SAVEDFILTERS__CREATE, SAVEDFILTERS__DELETE } from '@/store/actions'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import DataTableFilters from '@/components/DataTable/Filters/DataTableFilters.vue'
import DataTableSavedFilters from '@/components/DataTable/Filters/DataTableSavedFilters.vue'
import iconEdit from '@/assets/svg/rounded/edit.svg?inline'
import iconCheck from '@/assets/svg/rounded/check.svg?inline'
import iconChevronRight from '@/assets/svg/rounded/chevron-left.svg?inline'
import { CORRECT_QUERY } from '@/constants/dataTable'

interface Props {
  columns: Array<DataTableColumnItem>
}

interface Data {
  showFilters: boolean
  newFilterValue: string
  currentFilterValue: string
  newFilterEdit: boolean
  newFilters: Record<string, string | boolean>
  applyedFilterId: string
}
interface Methods {
  [SAVEDFILTERS__CREATE]: (payload: ReqSavedFilter) => void
  [SAVEDFILTERS__DELETE]: (payload: ResSavedFilter) => void
  newFilterNameCancel: () => void
  newFilterNameEdit: () => void
  newFilterNameSave: () => void
  returnValue: () => void
  changeFilter: () => void
  clearFilter: () => void
  changeFiltersVisible: () => void
  createFilter: () => void
  applySavedFilter: (filter: ResSavedFilter) => void
  deleteSavedFilter: (filter: ResSavedFilter) => void
}

interface Computed {
  inputValue: string
  filters: Record<string, string>
  filtersCounter: number
  filterApplied: boolean
  filterAppliedAndNotEmpty: boolean
  savedFiltersValue: ReqSavedFilter
  currentSavedFilters: ResSavedFilter[]
  lastFilter: ResSavedFilter
  disableSaveButton: boolean
  disableClearButton: boolean
  editedColumns: Array<DataTableColumnItem>
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    PaidLabel,
    DataTableFilters,
    DataTableSavedFilters,
    iconChevronRight,
    iconEdit,
    iconCheck,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    columns: {
      required: true,
    },
  },
  data() {
    return {
      showFilters: false,
      currentFilterValue: this.$tc('records.newFilter'),
      newFilterValue: '',
      newFilterEdit: false,
      newFilters: {},
      applyedFilterId: ''
    }
  },
  methods: {
    ...mapActions([SAVEDFILTERS__CREATE, SAVEDFILTERS__DELETE]),
    changeFiltersVisible() {
      this.showFilters = !this.showFilters
      this.$emit('input', this.showFilters)
    },
    changeFilter() {
      if (this.filterApplied) {
        return
      }
      const filterArr = Object.entries(this.newFilters)
      const filterString = filterArr.map((elem) => elem.join(':')).join(',')
      const query = Object.assign({}, this.$route.query)
      if (this.$route.query.offset) {
        delete query.offset
      }
      if (filterString.length === 0) {
        delete query.filter
        this.$router.push({ query: { ...query } })
      } else {
        this.$router.push({
          query: { ...query, filter: filterString },
        })
      }
    },
    clearFilter() {
      if (this.$route.query.filter) {
        this.newFilters = {}
        this.changeFilter()
      }
    },
    newFilterNameCancel() {
      this.newFilterEdit = false
      this.returnValue()
    },
    newFilterNameEdit() {
      this.newFilterEdit = true
      this.$nextTick(() => {
        ;(this.$refs['newFilterName'] as HTMLElement).focus()
      })
    },
    newFilterNameSave() {
      this.newFilterEdit = false
      this.currentFilterValue = this.newFilterValue
    },
    returnValue() {
      this.newFilterValue = this.currentFilterValue
    },
    createFilter() {
      const dublicateFilterName = this.currentSavedFilters.some((elem) => {
        return elem.title === this.savedFiltersValue.title
      })
      if (dublicateFilterName && this.applyedFilterId) {
        this.SAVEDFILTERS__DELETE({...this.savedFiltersValue, id: this.applyedFilterId})
      }
      this[SAVEDFILTERS__CREATE](this.savedFiltersValue)
    },
    applySavedFilter(filter) {
      this.applyedFilterId = filter.id
      this.clearFilter()
      if (filter.query) {
        filter.query.split(',').forEach((elem: string) => {
          const val: (string | boolean)[] = elem.split(':')
          if (val[1] === 'false') {
            val[1] = false
          }
          this.newFilters[val[0] as string] = val[1]
        })
      }
      const query = Object.assign({}, this.$route.query)
      const newQuery = { filter: filter.query }
      this.currentFilterValue = filter.title
      this.$router.push({
        query: { ...query, ...newQuery },
      })
    },
    deleteSavedFilter(filter) {
      this.$useConfirmDialog(
        [
          this.$tc('records.confirmDeleteFilter'),
            {
              type: 'danger',
              okText: this.$tc('common.remove'),
              cancelText: this.$tc('common.cancel'),
            },
        ],
        () => {
          this.SAVEDFILTERS__DELETE(filter)
        }
      )
    },
  },
  computed: {
    ...mapGetters({
      currentSavedFilters: 'getSavedFilters',
      lastFilter: 'getLastFilter'
    }),
    filterApplied() {
      function sortObject(obj: Record<string, string>) {
        const sortedObj = Object.assign({}, obj)
        Object.entries(obj).forEach((elem) => {
          if (elem[1].includes('|')) {
            sortedObj[elem[0]] = elem[1].split('|').sort().join('|')
          }
        })
        return Object.values(sortedObj).sort().join()
      }
      return (
        sortObject(this.newFilters as Record<string, string>) ===
        sortObject(this.filters as Record<string, string>)
      )
    },
    filterAppliedAndNotEmpty() {
      return Object.keys(this.newFilters).length !== 0 && this.filterApplied
    },
    inputValue() {
      return this.newFilterValue || this.currentFilterValue
    },
    filters() {
      if (!this.$route.query.filter) {
        return {}
      }
      const filterArr = (this.$route.query.filter as string).split(',')
      const filterObj: Record<string, string> = {}
      filterArr.forEach((elem) => {
        const filterItem = elem.split(':')
        if (filterObj[filterItem[0]]) {
          return (filterObj[filterItem[0]] = `${filterItem[1]}|${
            filterObj[filterItem[0]]
          }`)
        }
        filterObj[filterItem[0]] = filterItem[1]
      })
      return filterObj
    },
    filtersCounter() {
      return Object.keys(this.filters).length
    },
    savedFiltersValue() {
      const section: string = this.$route.path.slice(1)
      const title: string = this.newFilterValue
      const filteredQuery = Object.fromEntries(
        Object.entries(this.$route.query).filter(([key]) => {
          return CORRECT_QUERY.includes(key)
        }),
      )
      let query = ''
      if (typeof filteredQuery.filter === 'string') {
        query = filteredQuery.filter
      }
      return { section, title, query }
    },
    disableSaveButton() {
      const dublicateFilter = this.currentSavedFilters.some((elem) => {
        if (
          elem.query !== this.savedFiltersValue.query ||
          (elem.query === this.savedFiltersValue.query &&
            elem.title !== this.currentFilterValue)
        ) {
          return false
        }
        return true
      })
      if (dublicateFilter) {
        return true
      }
      return false
    },
    disableClearButton() {
      return !this.$route.query.filter
    },
    editedColumns() {
      const newColumns = this.columns.map((obj) => {
        let newValue = {}
        switch (obj.key) {
          case 'script_id':
            newValue = { type: 'script_id' }
            break
          case 'user_id':
            newValue = { type: 'user_id' }
            break
          case 'finish_type':
            newValue = { type: 'finish_type' }
            break
          default:
            newValue = obj.type
        }
        return {
          ...obj,
          ...newValue,
        }
      })
      return newColumns
    },
  },
  mounted() {
    this.returnValue()
  },
  watch: {
    'lastFilter.id'() {
      this.applyedFilterId = this.lastFilter.id
    }
  }
})
